module.exports = __webpack_public_path__ + "img/melbourne-2-1.36f066f0.svg";